import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            剧集索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按类型快速浏览，精准找到你想看的剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {indexData.map((item, idx) => (
            <div
              key={idx}
              className="group p-5 bg-background-100 rounded-lg text-center hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center mx-auto text-primary-500">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-400">
                {item.count}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}